import { Outlet } from "react-router-dom";
import Menu
 from "./navbar";

export default function MainLayout() {
  return (
    <>
      <Menu transparentNavbar={false} type={"sticky"}/>
      <Outlet />
    </>
  );
}
